import { LayerType } from '@/version-types';
import { type ITextEditAdapter } from './interface';
import { TableLayerAdapter } from './table-layer';
import { TextLayerAdapter } from './text-layer';
import { VectorLayerAdapter } from './vector-layer';

const adapters = {
    [LayerType.TEXT_LAYER]: new TextLayerAdapter(),
    [LayerType.TABLE]: new TableLayerAdapter(),
    [LayerType.VECTOR_LAYER]: new VectorLayerAdapter(),
};

export const getAdapter = (layerType: LayerType) => {
    if (Reflect.has(adapters, layerType)) {
        return adapters[layerType] as ITextEditAdapter;
    }
    return null;
};
